module.exports = __webpack_public_path__ + "img/programme2.71f01e31.png";